import { parseLanguageTag } from '@sozialhelden/ietf-language-tags';
import { clientLanguagesData } from 'Shared/TranslatableTextContent/clientLanguagesData';

export default function useLanguage(limitToFlow = true) {
  const tag = parseLanguageTag(
    window.navigator.userLanguage || window.navigator.language,
    // Set to `true` for returning `undefined` for invalid tags,
    // outputting errors to the console.
    // Set to `false` to throw an error if a given tag is invalid.
    // The library tries to give helpful feedback for typical errors in tags.
    true,
    // Allows you to use your own logging function. Supply `null` to suppress console output.
    null
  );
  
  const defaultLanguage = useDefaultFlowLanguage()
  const hasBuilder = useSel(s => !!s.builder)
  const { editableLanguagesData, publishedLanguagesData } = useLanguagesData()

  const localLanguage: string | null = useSel(s => s.local?.language || null)
  const urlLanguage: string | null = new URLSearchParams(window.location.search).get("lang") || null
  const tagLanguage = tag?.language || null

  // Determine language preference order: local setting, URL param, browser tag, flow default.
  const desiredLanguage = localLanguage || urlLanguage || tagLanguage || defaultLanguage;
  if (!limitToFlow) {
    return desiredLanguage
  }

  const languageList = hasBuilder ? Object.keys(editableLanguagesData || {}) : Object.keys(publishedLanguagesData || {});
  const languagePrefix: string = languageList.find(lang => desiredLanguage.startsWith(lang)) || defaultLanguage;
  return languagePrefix
}

export function useDefaultFlowLanguage(): string {
  const { defaultLanguage } = useSel(s => s.taker?.flow || s.builder?.flow || {})
  return defaultLanguage || 'en'
}

export function useLanguagesData() {
  const { defaultLanguage, editableLanguages, publishedLanguages } = useSel(s => s.builder?.flow || s.taker?.flow || {})

  const data = clientLanguagesData()
  const fallback = { en: data.en }

  const pickOrFallback = langs =>
    Object.keys(_.pick(data, [defaultLanguage, ...(langs || [])])).length
      ? _.pick(data, [defaultLanguage, ...(langs || [])])
      : fallback

  return {
    editableLanguagesData: pickOrFallback(editableLanguages),
    publishedLanguagesData: pickOrFallback(publishedLanguages)
  }
}
